import {
  MRD_DENEST_IMPC_MAPPING_ADD_REQUEST,
  MRD_DENEST_IMPC_MAPPING_ADD_SUCCESS,
  MRD_DENEST_IMPC_MAPPING_ADD_FAILURE,
  MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST,
  MRD_DENEST_IMPC_MAPPING_DEACTIVATE_SUCCESS,
  MRD_DENEST_IMPC_MAPPING_DEACTIVATE_FAILURE,
} from './types/DenestImpcMappingActionTypes';

export function postDenestImpcMappingAddRequestActionCreator(selectedDenestImpc, selectedMrdImpc, selectedMrdOperator, selectedValidFrom, selectedValidTo) {
  return {
    type: MRD_DENEST_IMPC_MAPPING_ADD_REQUEST,
    payload: {
      params: {
        denestImpc: selectedDenestImpc,
        mrdImpc: selectedMrdImpc,
        mrdOperator: selectedMrdOperator,
        validFrom: selectedValidFrom,
        validTo: selectedValidTo,
      },
    },
  };
}

export function postDenestImpcMappingAddSuccessActionCreator(data) {
  return {
    type: MRD_DENEST_IMPC_MAPPING_ADD_SUCCESS,
    payload: data,
  };
}

export function postDenestImpcMappingAddFailureActionCreator(error) {
  return {
    type: MRD_DENEST_IMPC_MAPPING_ADD_FAILURE,
    payload: error,
    error: true,
  };
}

export function putDenestImpcMappingDeactivateRequestActionCreator(updatedRecords) {
  return {
    type: MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST,
    payload: {
      params: updatedRecords,
    },
  };
}

export function putDenestImpcMappingDeactivateSuccessActionCreator(data) {
  return {
    type: MRD_DENEST_IMPC_MAPPING_DEACTIVATE_SUCCESS,
    payload: data,
  };
}

export function putDenestImpcMappingDeactivateFailureActionCreator(error) {
  return {
    type: MRD_DENEST_IMPC_MAPPING_DEACTIVATE_FAILURE,
    payload: error,
    error: true,
  };
}
